import React from 'react';
import styles from './PreviewOverlay.module.scss';

const PreviewOverlay: React.FC = () => (
  <div className={styles.overlay}>
    <span className={styles.button}>プレビュー</span>
  </div>
);

export default PreviewOverlay;
